const base = {
  default: {
    '.carouselHeroSlider-slider': {
      backgroundColor: 'blue.10'
    }
  }
};

const scale = {
  default: {
    '.carouselHeroSlider-slider': {
      backgroundColor: 'coolGrey.10'
    }
  }
};

const carouselSlider = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale,
    spark: base
  }
};

export type CarouselSliderVariantsType = 'default';
export const carouselSliderVariants = Object.keys(base) as CarouselSliderVariantsType[];

export default carouselSlider;
